var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23024D",
    fillRule: "evenodd",
    d: "M10.623 5.311A5.311 5.311 0 1 1 0 5.311a5.311 5.311 0 0 1 10.623 0m5.666.001c0 2.705-1.163 4.898-2.597 4.898s-2.597-2.193-2.597-4.898S12.258.414 13.692.414s2.597 2.193 2.597 4.898m1.593 4.426c.489 0 .885-1.981.885-4.426 0-2.444-.396-4.426-.885-4.426-.49 0-.886 1.982-.886 4.426s.397 4.426.886 4.426",
    clipRule: "evenodd"
  })));
};
export default SvgMedium;